import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'price' })
export class PricePipe implements PipeTransform {
  transform(value: number, digits = 2, currencySymbol = ' €'): string {
    if (typeof value === 'string') {
      value = parseFloat(value);
    }

    if (typeof value === 'number') {
      return value.toFixed(digits).replace('.', ',') + currencySymbol;
    }

    return '';
  }
}
